import { useTranslation } from 'next-i18next';
import type { UserVoucherResDisplayStatus } from '@/api/gen/_model/userVoucherResDisplayStatus';
import { Chip } from '@/ui_v3/components/chip';
import { VOUCHER_STATUS_LABELS } from './type';
export const VoucherStatusChip = ({
  status
}: {
  status: UserVoucherResDisplayStatus;
}) => {
  const {
    t
  } = useTranslation(['billing']);
  const isDisabled = status === 'USED' || status === 'EXPIRED' || status === 'DEACTIVATED';
  const isUsing = status === 'IN_USE';
  return <Chip size="sm" className={`mobile-lg:min-h-[26px] mobile-lg:px-xs mobile-lg:text-body-sm-semibold ${isDisabled ? 'border-alternative text-disabled' : isUsing ? 'border-strong-assistive text-strong' : 'border-alternative text-neutral'}`} data-sentry-element="Chip" data-sentry-component="VoucherStatusChip" data-sentry-source-file="VoucherStatusChip.tsx">
      {t(VOUCHER_STATUS_LABELS[status])}
    </Chip>;
};